var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "availability-list-item availability-grid" },
    [
      _c("div", { staticClass: "availability-grid__address address" }, [
        _vm.info.metro.length
          ? _c(
              "div",
              { staticClass: "metro" },
              _vm._l(_vm.info.metro, function(metro) {
                return _c("div", { key: metro.id }, [
                  _c("span", { style: { backgroundColor: metro.line.color } }),
                  _vm._v(_vm._s(metro.name) + "\n      ")
                ])
              }),
              0
            )
          : _vm._e(),
        _c("span", [_vm._v(_vm._s(_vm.info.address))]),
        _vm.isNeedPrepay || _vm.isNeedQrCode
          ? _c(
              "div",
              { staticClass: "availability-list-item__markers" },
              [
                _vm.isNeedPrepay
                  ? _c("tag", {
                      staticClass: "availability-list-item__marker",
                      attrs: {
                        title: "100%&nbsp;&nbsp;предоплата",
                        width: "120px",
                        color: "#ffb71b"
                      }
                    })
                  : _vm._e(),
                _vm.isNeedQrCode
                  ? _c("tag", {
                      staticClass: "availability-list-item__marker",
                      attrs: {
                        title: "Вход по QR",
                        width: "80px",
                        color: "#c1e0e0"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _c(
        "div",
        {
          staticClass: "availability-list-item__info availability-grid__delay"
        },
        [
          _c("span", { staticClass: "availability-list-item__info-title" }, [
            _vm._v("Наличие:")
          ]),
          _c("span", { staticClass: "availability-list-item__info-value" }, [
            _vm._v(_vm._s(_vm.delayTitle))
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "availability-list-item__info date availability-grid__can-pickup"
        },
        [
          _c("span", { staticClass: "availability-list-item__info-title" }, [
            _vm._v("Можно забрать:")
          ]),
          _c(
            "span",
            { staticClass: "availability-list-item__info-value blue" },
            [_vm._v(_vm._s(_vm.closestDate))]
          )
        ]
      ),
      _c("to-cart", {
        staticClass:
          "availability-list-item__pickup-button availability-grid__end",
        attrs: {
          product: _vm.PRODUCT,
          "sku-id": _vm.ACTIVE_SKU.id,
          "hide-icons": "",
          "hide-notification": "",
          "store-id": _vm.info.id,
          "text-add": "Забрать из магазина"
        },
        on: {
          add: function($event) {
            return _vm.$emit("add-to-cart", _vm.info.id)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }